import slice from '../slice';

export default function dropLastWhile(pred, xs) {
  var idx = xs.length - 1;
  while (idx >= 0 && pred(xs[idx])) {
    idx -= 1;
  }
  return slice(0, idx + 1, xs);
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_dropLastWhile.js
// module id = 2538
// module chunks = 1